import styled from "styled-components";

export const Contenido = styled.div`
  position: relative;

  --elemento-border: #888888 0.01rem solid;
  --cabecera-elemento-font-size: ${props => (props.$escomputadora ? "0.8rem" : "1.65rem")};
  --cabecera-elemento-color: #525252;

  .inputSelectGenerico {
    width: 100%;
    box-sizing: border-box;
    padding: 0.2rem;
    height: ${props => (props.$escomputadora ? "2.5rem" : "5rem")};
    font-size: var(--contenido-elemento-font-size);
    font-weight: var(--contenido-elemento-font-weight);
    outline: none;
    border: var(--elemento-border);
    border-radius: ${props => (props.$escomputadora ? "0.35rem" : "0.7rem")};
    padding-top: ${props => (props.$escomputadora ? "1.2rem" : "2rem")};
    padding-left: ${props => (props.$escomputadora ? "0.5rem" : "1rem")};
  }
  .labelInputSelectGenerico{
    background-color: var(--cabecera-elemento-background-color);
    position: absolute;
    left: ${props => (props.$escomputadora ? "0.7rem" : "1rem")};
    font-size: var(--cabecera-elemento-font-size);
    color: var(--cabecera-elemento-color);
  }
  .SelectGenerico {
    box-sizing: border-box;
    
    background-color: rgb(255, 255, 255);
    z-index: 1;
    width: 100%;
    max-height: ${(props) => (props.$escomputadora ? "10rem" : "20rem")};
    overflow: auto;
    font-size: ${(props) => (props.$escomputadora ? "1rem" : "1.7rem")};
    position: absolute;
    transition: max-height 0.1s ease;
    border: #888888 0.01rem solid;
    border-radius: ${(props) => (props.$escomputadora ? "0.5rem" : "1rem")};
    box-shadow: 0 0 1rem #cccccc;
  }

  .mostrarSelectGenerico {
    max-height: 0;
    border:none;
    transition: max-height 0.1s ease;
  }

  .optionGenerico{
    padding: ${(props) => (props.$escomputadora ? "0rem 0.5rem" : "0.3rem 1rem ")};
  }
  .optionGenerico:hover {
    background-color: #cccccc;
    cursor: pointer;
    transition: 0.1s all;
  }
`;
